import { render, staticRenderFns } from "./other-menus-modal.vue?vue&type=template&id=5fde376a&scoped=true&"
import script from "./other-menus-modal.vue?vue&type=script&lang=js&"
export * from "./other-menus-modal.vue?vue&type=script&lang=js&"
import style0 from "./other-menus-modal.vue?vue&type=style&index=0&id=5fde376a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fde376a",
  null
  
)

export default component.exports